module.exports = __webpack_public_path__ + "img/ic_drawer_1.1b572881.svg";